module.exports = __webpack_public_path__ + "img/icon_update_image.4d34122f.svg";